import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../context/AuthContext'
import { consultaPermisos, esAdminDeLaClinica, yaLlegaron } from '../services/permisosDelServidor'

// Permisos funcionales efectivos del usuario en sesión: { clave: bool }. Se resuelven en el backend
// (superadmin/admin > override usuario > override rol > default). El frontend los usa para ocultar
// secciones DENEGADAS (p. ej. la pestaña de cobros) y para que el menú oculte un módulo denegado.
// `permiso(clave)` devuelve true salvo que esté explícitamente denegado (mientras carga, no oculta nada).
// Si quien prueba la aplicación está "viendo como" otro rol (verComoRol), se piden los permisos de ESE
// rol para que la previsualización sea fiel. Desde B-1000 el backend solo lo permite a la cuenta real
// del equipo de Biango (superadmin) que además administra la clínica; a los demás AuthContext les da
// verComoRol y verComoUsuario a null, así que aquí se piden siempre los suyos.
export function usePermisos() {
  const { verComoRol, verComoUsuario } = useAuth() || {}
  // Ver como USUARIO manda sobre ver como ROL (son excluyentes, pero el orden lo deja explicito):
  // los permisos de una persona incluyen sus overrides propios y sus agendas, que es justo lo que
  // hace que "ver como Ana" no sea lo mismo que "ver como recepcion".
  // LA CONSULTA NO SE ESCRIBE AQUI (services/permisosDelServidor): la comparte con AuthContext, que
  // necesita la MISMA respuesta para el usuario REAL. Dos redacciones de la misma peticion es como
  // se llega a que dos mitades de la aplicacion decidan con cuerpos distintos.
  const { data } = useQuery(consultaPermisos({
    verComoUsuarioId: verComoUsuario?.id || null,
    verComoRol: verComoRol || null,
  }))
  const perms = data || {}
  const permiso = (clave) => perms[clave] !== false   // undefined (cargando/sin clave) => permitido
  // Rol de serie del que hereda (para roles personalizados). Cae al propio rol si no está.
  // idsUsu = agendas asignadas, SIEMPRE frescas (el `user` del navegador se queda con las del
  // login: asignar una agenda no surtía efecto hasta cerrar sesión). `null` mientras carga, para
  // poder distinguir "todavía no lo sé" de "no tiene ninguna".
  //
  // `esAdmin` = ¿ES ADMINISTRADORA DE ESTA CLINICA? La contesta el SERVIDOR (`_es_admin`, la misma
  // decision con la que las rutas dan el 403) y aqui solo se lee. Sale del usuario EFECTIVO, asi que
  // un administrador que este "viendo como" recepcion ve exactamente lo que veria recepcion.
  return {
    perms,
    permiso,
    baseRol: perms._base_rol || null,
    idsUsu: data?._ids_usu || null,
    // t381 · ¿solo ve lo suyo? (el colaborador de serie o un rol propio marcado; lo decide el servidor, services/soloLoSuyo)
    soloLoSuyo: perms._solo_lo_suyo === true,
    esAdmin: esAdminDeLaClinica(perms),
    permisosListos: yaLlegaron(perms),
  }
}

export default usePermisos
